export default __webpack_public_path__ + "images/727c66f0efa252dc7288c68854210f79-educators.webp";